export const MARKET = [
  {
    label: 'Time on Market',
    key: 'time_on_market'
  },
  {
    label: 'Market Share',
    key: 'market_share'
  }
];

export const CALCULATION = [
  { label: 'Median', key: 'median' },
  { label: 'Average', key: 'average' }
];

export const MIN_SOLD_COUNT_FOR_HEAT = 6;

export const FRONTAGES = [8.5, 10.5, 12.5, 14, 16];

export const DEPTHS = [21, 25, 28, 32];
